import { GetCittaQuery, GetProvinciaQuery } from '../../_graphql/generated';

export type ProvinciaState = {
  loading: boolean;
  lista: GetProvinciaQuery['unita_amministrativa_provincia'];
  failure: any;
};

export const initialProvinciaState: ProvinciaState = {
  loading: false,
  lista: [],
  failure: '',
};
